import React, { useCallback, useEffect, useMemo, useRef } from 'react'
import _ from 'lodash'
import { MatchLevelPlayoffDateSchedule, MatchLevelDateSchedule, DateMatches } from './MatchLevelPlayoffDateSchedule';
import MatchSectionDateSchedule from './MatchSectionDateSchedule';
import { gEnums } from 'global/enums/globalEnums';
import { _matchDisplayTypes } from './MatchContent';
import { uniqueKey } from 'global/common/keys';
import { animate } from 'framer-motion';
import { DateHeader } from '../schedule/DateHeader';
import { SectionHeader } from '../schedule/SectionHeader';
import { _matchLsTypes } from 'projectSpecific/sports/cnr/reducers/SportsDataReducer';
import { SectionSchedule } from './SectionSchedule';

const _applyScroll = true

export const LevelSchedule = ({
  lsdm,
  levelKey,
  levelGroup,
  teamKey,
  matchDisplayType,
  matchScheduleDisplayType,
  team_fav_keys,
  showMissingMatches,
  activeTabIndex,
  activeTab,
  lastLevelDate,
  gotoSelected,
  matchesSummary
}) => {

  // console.log('lsdm', matchDisplayType, lsdm)

  const dateToTimestamp = (dateStr) => {
    const [month, day, year] = dateStr.split('/').map(Number);
    return new Date(year, month - 1, day).getTime();
  };

  const sortedDateObject = (obj) => _.fromPairs(
    _.sortBy(
      _.toPairs(obj),
      ([date]) => dateToTimestamp(date)
    )
  );

  const levelSchedules = useMemo(() => {

    const divs_all = []

    const _lsdm = _.omit(lsdm, [_matchLsTypes.Non, _matchLsTypes.nonDistrict, _matchLsTypes.nonSection])

    const _aaaa = sortedDateObject(_lsdm)

    // loop the dates
    _.forEach(_aaaa, (matches_date, dateKey) => {

      const dateHeader = <DateHeader startDate={dateKey} counts={matchesSummary} showMissingMatches={showMissingMatches} />

      const divs_sections = _.map(matches_date, (matches_sections, sectionKey) => (
        <SectionSchedule
          levelKey={levelKey}
          sectionKey={sectionKey}
          matches_sections={matches_sections}
          teamKey={teamKey}
          matchDisplayType={matchDisplayType}
          matchScheduleDisplayType={matchScheduleDisplayType}
          team_fav_keys={team_fav_keys}
        />
      ))

      const div_date = <div className='match-level-date'>
        {dateHeader}
        {divs_sections}
      </div>

      divs_all.push(div_date)

    }) // end dates

    return divs_all
  }, [lsdm, matchDisplayType])

  return <div className='level-matches'>
    {levelSchedules}
  </div>

  console.log('lsdm', levelKey, lsdm)

  // 🔹 Local ref always exists 
  const dateRefs = useRef({})

  const setDateRef = useCallback((el, key) => {
    if (el) dateRefs.current[key] = el;
  }, []);

  const applyRef = matchDisplayType === _matchDisplayTypes.levelMatches

  useEffect(() => {
    if (!levelKey || !applyRef) return
    const formatToday = () => {
      const t = new Date()
      return (
        String(t.getMonth() + 1).padStart(2, '0') + '/' +
        String(t.getDate()).padStart(2, '0') + '/' +
        t.getFullYear()
      )
    }

    const todayStr = formatToday()
    const prefix = `${levelKey}-`

    const parse = (mmddyyyy) => {
      const [m, d, y] = mmddyyyy.split('/')
      return new Date(y, m - 1, d)
    }

    const today = new Date()
    today.setHours(0, 0, 0, 0)

    const entries = Object.entries(dateRefs.current)
      .filter(([key]) => key.startsWith(prefix))
      .map(([key, el]) => {
        const dateStr = key.replace(prefix, '')
        return {
          key,
          el,
          date: parse(dateStr),
          isToday: dateStr === todayStr,
        }
      })
      .sort((a, b) => a.date - b.date)


    // exact today → next future → last past
    let target =
      entries.find(e => e.isToday) ||
      entries.find(e => e.date >= today) ||
      entries[entries.length - 1]
    target?.el?.scrollIntoView({ behavior: 'instant', block: 'start' })
  }, [levelKey])


  useEffect(() => {
    if (gotoSelected) {
      console.log('gotoSelected', gotoSelected)
    }
  }, [gotoSelected])

  // 🔹 Scroll to the div matching the provided date
  // useEffect(() => {
  //   if (_applyScroll && activeTab && applyRef) {
  //     const el = localRef.current?.[levelKey];
  //     if (el) {
  //       console.log('el', el)
  //       // el.scrollIntoView({ behavior: 'instant', block: 'start' })
  //     }
  //   }
  // }, [levelKey, activeTabIndex, activeTab, applyRef])

  // loop the levelGroup (startDate, matches, matches_playoffs)

  // const divs_matches = _.map(levelGroup, ({ matches, matches_playoffs, startDate }) => {

  //   const counts = matchesSummary ?? {}

  //   let _matches = matches

  //   if (showMissingMatches) {
  //     _matches = _.filter(matches, (m) => !!m?._status.isMissing);
  //   }

  //   let seasonDivs;
  //   let playoffDivs;

  //   if (_matches) {
  //     // get the normal level matches
  //     seasonDivs = <MatchLevelDateSchedule
  //       levelKey={levelKey}
  //       matches={_matches}
  //       teamKey={teamKey}
  //       matchDisplayType={matchDisplayType}
  //       matchScheduleDisplayType={matchScheduleDisplayType}
  //       team_fav_keys={team_fav_keys}
  //     />
  //   }

  //   if (matches_playoffs) {
  //     // get the playoff level matches
  //     playoffDivs = <MatchLevelPlayoffDateSchedule
  //       matches_playoffs={matches_playoffs}
  //       teamKey={teamKey}
  //       matchDisplayType={matchDisplayType}
  //       matchScheduleDisplayType={matchScheduleDisplayType}
  //       team_fav_keys={team_fav_keys}
  //     />
  //   }

  //   // combine the seasonDivs and playoffDivs
  //   const allMatchLevelDivs = _.concat(seasonDivs, playoffDivs)

  //   if (allMatchLevelDivs) {
  //     return (
  //       <div
  //         ref={el => setDateRef(el, `${levelKey}-${startDate}`)}
  //         key={uniqueKey(levelKey, 'md', startDate)}
  //         className={`date-section-wrapper ${levelKey}`}
  //       >
  //         <MatchSectionDateSchedule
  //           levelKey={levelKey}
  //           startDate={startDate}
  //           counts={counts}
  //           matchDivs={allMatchLevelDivs}
  //           showMissingMatches={showMissingMatches}
  //         />
  //       </div>
  //     )
  //   }
  // })

  return <div>LSS</div>
  // return divs_matches
}
